import { ItemOffer } from '@dgx-pr-spa/shared/util';
import { ActionError } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const loadItemOffer = createAction(
  '[Additional Services] Load Item Offer'
);

export const loadItemOfferSuccess = createAction(
  '[Additional Services] Load Item Offer Success',
  props<{ payload: ItemOffer }>()
);

export const loadItemOfferFail = createAction(
  '[Additional Services] Load Item Offer Fail',
  props<{ payload: ActionError }>()
);

export const resetItemOffer = createAction('[Item Offer] Reset Item Offer');

export type ItemOfferActions =
  | typeof loadItemOffer
  | typeof loadItemOfferSuccess
  | typeof loadItemOfferFail
  | typeof resetItemOffer;
